<template>
    <div :style="cssVar" class="_m-ModulesPageFormulaire">
        <template v-if="terminer === false">
            <header class="_m-ModulesPageFormulaire__header">
                <div class="_m-ModulesPageFormulaire__header__container">
                    <div class="_m-ModulesPageFormulaire__header__logo">
                        <img src="https://clients.nessleads.com/site/assets/images/logoNLBL.png">
                    </div>
                    <div class="_m-ModulesPageFormulaire__header__steps">
                        <span class="progress">
                            <div class="progress__label">{{progressPourcentage}}% complété
                                <span v-if="extra.displayTime">- {{estimateTime}}s restantes</span></div>
                            <div class="progress__container">
                                <div :style="{'width' : progressPourcentage+'%'}" class="progress__bar"></div>
                            </div>
                        </span>
                    </div>
                </div>
            </header>
            <div class="_m-ModulesPageFormulaire__content">
                <component
                        :class="{
                        '_m-ModulesPageFormulaire__item' : true,
                        '_m-ModulesPageFormulaire__item--active' : item.id === idCurrent,
                        '_m-ModulesPageFormulaire__item--passed' : item.id < idCurrent,
                    }"
                        :disabled="idChecked < item.id"
                        :active="item.id === idCurrent"
                        :is="getComponents(item)"
                        :item="item"
                        :last="maxStep == item.id"
                        :key="item.id"
                        @input="nextItem(item)"
                        v-for="item of steps"
                        v-model="formData[item.id]"
            ></component>
                <div :class="{
                        '_m-ModulesPageFormulaire__item' : true,
                        '_m-ModulesPageFormulaire__item--submit' : true,
                        '_m-ModulesPageFormulaire__item--active' : maxStep+1 === idCurrent,
                    }">
                    <p class="_m-ModulesPageFormulaire__text-submit">
                        Merci !<br> <span>Afin d'obtenir votre tarif, merci de cliquer sur le bouton suivant :</span>
                    </p>
                    <button
                            :class="{
                        '_m-ModulesPageFormulaire__submit' : true,
                        '_m-ModulesPageFormulaire__submit--visible' : maxStep+1 === idCurrent
                    }"
                            @click="validation"
                    >Obtenir mon tarif
                    </button>
                </div>
            </div>

        </template>
        <p v-else>Merci pour vos informations<br/>Vous recevrez rapidement les tarifs pour votre besoin en leads frais & qualifiés.</p>
    </div>
</template>
<script>
  import FormText from '@/components/elements/FormText';
  import FormChoice from '@/components/elements/FormChoice';
  import {mapActions, mapGetters} from 'vuex';
  import axios from 'axios';

  export default {
    name: 'ModulesPageFormulaire',
    data() {
      return {
        idCurrent: 1,
        idChecked: 1,
        formData: {},
        terminer: false,
        toucheEvent: {},
      };
    },
    mounted() {
      this.initData();
      window.addEventListener('keyup', this.handlerKeyup);
      window.addEventListener('wheel', this.handlerMouse);

      window.addEventListener('touchstart', this.handleStart, {passive: false});
      window.addEventListener('touchmove', this.handleMove, {passive: false});
      this.changeTitle();
    },
    methods: {
      changeTitle() {
        document.title = this.meta.title;
      },
      ...mapActions(['initData']),
      validation() {
        //on valide le formulaire en prenant en compte les LINKS
        //si on arrive ici c'est que le formulaire est valide
        if (this.maxStep + 1 === this.idChecked) {
          axios.post(this.extra.endpoint, this.formData).then(() => {
            this.terminer = true;
          });
        }

      },
      handleStart($event) {
        this.toucheEvent.y = $event.touches[0].clientY;
      },
      handleMove($event) {
        //$event.preventDefault();
        $event.stopPropagation();
        $event.stopImmediatePropagation();
        let y = $event.touches[0].clientY;
        let deplacement = this.toucheEvent.y - y;
        if (deplacement > 150) {
          this.toucheEvent.y = y;
          this.next();
        }
        if (deplacement < -150) {
          this.toucheEvent.y = y;
          this.prev();
        }
      },
      handlerMouse($event) {
        if ($event.deltaY > 0) {
          this.next();
        }

        if ($event.deltaY < 0) {
          this.prev();
        }

      },
      handlerKeyup($event) {
        if ($event.key === 'ArrowDown') {
          this.next();
        }

        if ($event.key === 'ArrowUp') {
          this.prev();
        }
      },
      prev() {
        if (this.extra.voirQuestions) {
          if (this.idCurrent > this.minStep) {
            this.idCurrent--;
          }
        }
        else {
          if (this.idChecked > this.minStep && this.idCurrent > this.minStep) {
            this.idCurrent--;
          }
        }
      },
      next() {
        if (this.extra.voirQuestions) {
          if (this.idCurrent < this.maxStep) {
            this.idCurrent++;
          }
        }
        else {
          if (this.idCurrent < this.idChecked) {
            this.idCurrent++;
          }
        }
      },
      nextItem(item) {
        let data = this.formData[item.id];
        if (data.link) {
          this.idCurrent = data.link;
          //on ajoute les étapes sauté dans le form data en vide et avec un flag autre chemin
          for (let i = item.id + 1; i < this.idCurrent; i++) {
            this.formData[i] = {'value': null, 'other_path': true};
          }
        }
        else {
          this.idCurrent = item.id + 1;
        }

        if (this.idCurrent >= this.maxStep + 2) {
          this.idCurrent--;
          this.idChecked = this.idCurrent;
        }
        else {
          this.idChecked = this.idCurrent;
        }

      },
    },
    computed: {
      ...mapGetters(['steps', 'extra', 'styles', 'meta']),
      orderFormData() {
        let formOrder = [];
        for (let dataK in this.formData) {
          let data = this.formData[dataK];
          formOrder.push({...data, id: dataK});
        }
        formOrder.sort((a, b) => {

          let aId = parseInt(a.id);
          let bId = parseInt(b.id);

          if (aId > bId) {
            return 1;
          }
          if (aId < bId) {
            return -1;
          }
          return 0;
        });

        return formOrder;
      },
      estimateTime() {
        return (this.steps.length - this.idChecked) * 5;
      },
      progressPourcentage() {

        let pourcentage = Math.ceil((this.idChecked - 1) * 100 / this.steps.length);
        if (pourcentage > 100) {
          pourcentage = 100;
        }
        return pourcentage;
      },
      cssVar() {
        return {
          '--color-background': this.styles.background,
          'background': this.styles.background,
        };
      },
      minStep() {
        let min = 900000;
        for (let step of this.steps) {
          if (step.id < min) {
            min = step.id;
          }
        }
        return min;
      },
      maxStep() {
        let max = 0;
        for (let step of this.steps) {
          if (step.id > max) {
            max = step.id;
          }
        }
        return max;
      },

      getComponents() {
        return (item) => {
          if (item.type === 'text') {
            return FormText;
          }

          if (item.type === 'choice') {
            return FormChoice;
          }

          return '';
        };
      },
    },
  };
</script>
<style scoped>
    ._m-ModulesPageFormulaire {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        overflow: hidden;
        background: var(--color-background);
        transition: 200ms;
    }

    ._m-ModulesPageFormulaire__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        height: calc(100% - 90px);
        left: 0;
        right: 0;
        width: 100%;
        margin: 0 auto;
        z-index: 1;
    }

    ._m-ModulesPageFormulaire__item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: absolute;
        height: auto;
        max-height: 100%;
        left: 0;
        right: 0;
        width: 100%;
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
        padding: 0 25px;
        margin-top: 20%;
        transition: margin 500ms, opacity 700ms;
        opacity: 0;
        overflow: auto;
        z-index: 1;
    }

    ._m-ModulesPageFormulaire__item._m-ModulesPageFormulaire__item--passed {
        transition: margin 200ms, opacity 300ms;
        opacity: 0;
        margin-top: -20%;
        z-index: 2;
    }

    ._m-ModulesPageFormulaire__item._m-ModulesPageFormulaire__item--active {
        margin-top: 45px;
        opacity: 1;
        z-index: 100;
    }

    ._m-ModulesPageFormulaire__item._m-ModulesPageFormulaire__item--active + ._m-ModulesPageFormulaire__item._m-ModulesPageFormulaire__item {
        transition: margin 400ms, opacity 600ms;

    }

    ._m-ModulesPageFormulaire__item--submit {
        padding: 25px;
        justify-content: center;
        align-items: center;
    }


    ._m-ModulesPageFormulaire__header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 90px;
        z-index: 500;
    }

    ._m-ModulesPageFormulaire__header__container {
        max-width: 1280px;
        padding: 0 25px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 90px;
    }

    ._m-ModulesPageFormulaire__header__logo {
        max-width: 200px;
        margin-right: 10px;
        flex: 1 0 100px;
    }

    ._m-ModulesPageFormulaire__header__logo img {
        max-width: 100%;
    }

    ._m-ModulesPageFormulaire__submit {
        border: none;
        border-radius: 4px;
        height: 40px;
        line-height: 40px;
        font-size: 20px;
        font-weight: bold;
        margin-top: 150px;
        width: 150px;
        left: 0;
        right: 0;
        opacity: 0;
        transition: 800ms;
        margin: 0 auto;
        background-color: rgb(255, 255, 255);
        color: rgb(128, 128, 128);
        z-index: 900;
        cursor: pointer;
        margin: 15px;
    }

    ._m-ModulesPageFormulaire__submit:focus {
        outline: none;
    }

    ._m-ModulesPageFormulaire__submit:hover {
        opacity: 1;
        transition: 200ms;
    }

    ._m-ModulesPageFormulaire__submit:active {
        background-color: rgb(220, 220, 220);
    }

    ._m-ModulesPageFormulaire__submit--visible {
        opacity: 0.8;
        margin-top: 0px;
    }

    ._m-ModulesPageFormulaire__header__steps {
        max-width: 140px;
    }

    ._m-ModulesPageFormulaire__text-submit {
        font-size: 1.5rem;
    }


    .progress {
        display: flex;
        flex-direction: column;
        font-size: 1.2rem;
    }

    .progress__label {
        text-align: left;
        margin-bottom: 5px;
    }

    .progress__container {
        width: 200px;
        max-width: 100%;
        border-radius: 4px;
    }

    .progress__bar {
        height: 5px;
        background: white;
        transition: 500ms;

    }
	
	._m-ModulesPageFormulaire__submit{
		opacity: 1 !important;
		margin-top: 0;
		width: 270px;
		height: 60px;
		font-size: 25px;
		color: #0042da;
		border: 2px solid #75deff;
	}
	
	@media (max-width: 600px) {
		._m-ModulesPageFormulaire__text-submit {
			font-size: 1.5rem;
			margin-top:-30px;
		}
	}

</style>
